var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isSlots)?_c('label',{attrs:{"for":_vm.labelFor,"form":_vm.form}},[_vm._t("default")],2):_c('label',{attrs:{"for":_vm.labelFor,"form":_vm.form},domProps:{"innerHTML":_vm._s(_vm.content)}})
}
var staticRenderFns = []

export { render, staticRenderFns }